import Image from '@/components/ui/image'
import colors from '@/constants/colors'
import { cx } from '@/utils/strings'
import { Asset } from 'contentful'

interface PageBackgroundProps {
  pageBackgroundImage: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>
  backgroundColor?: string | undefined
}

export default function PageBackground({ pageBackgroundImage, backgroundColor }: PageBackgroundProps) {
  const { indigoBlue, primaryBlue, lightGray, white } = colors
  return (
    <div className="hidden lg:block absolute z-0 top-[-50px] left-0 right-0 w-full [&_svg]:fill-none [&_svg]:w-full [&_figure]:w-full [&_img]:w-full [&_svg]:opacity-70">
      <div
        className={cx(
          'relative max-h-[800px] overflow-hidden after:absolute after:z-1 after:inset-x-0 after:bottom-0 after:md:h-[20%] after:lg:h-[40%] after:bg-gradient-to-b after:from-transparent ',
          backgroundColor === white && `after:to-white`,
          backgroundColor === lightGray && `after:to-secondary-50`,
          backgroundColor === primaryBlue && `after:to-primaryBlue`,
          backgroundColor === indigoBlue && `after:to-indigoBlue`,
          'dark:after:to-secondary-800'
        )}
      >
        <Image image={pageBackgroundImage} />
      </div>
    </div>
  )
}
